import * as Api from '@ViewModels';
import { Countries } from '../../web/components/ValueSelectors/CountrySelector';

/**
 * Checks if address is complete
 * @source Original location: UiUtils.ts.backup line 2135
 */
export const isAddressComplete = (address: Api.IAddress) => {
	return address.address1 && address.city && address.stateProvince && address.postalCode && address.country;
};

/**
 * Checks if address has required HWC recipient fields
 * @source Original location: UiUtils.ts.backup line 2139
 */
export const hasRequiredHwcRecipientAddressFields = (address: Api.IAddress) => {
	return address.address1 && address.city && address.stateProvince && address.postalCode;
};

/**
 * Gets multiline formatted address
 * @source Original location: UiUtils.ts.backup line 2143
 */
export const getMultilineFormattedAddress = (address: Api.IAddress) => {
	const countryName = (
		Countries.find(x => x.value === address?.country) || {
			name: address?.country,
		}
	).name;
	return `${address.address1 ? `${address.address1}\n` : ''}${address.address2 ? `${address.address2}\n` : ''}${
		address.city ? `${address.city}, ` : ''
	}${address.stateProvince ? `${address.stateProvince} ` : ''}${address.postalCode ? address.postalCode : ''}\n${
		countryName ? countryName : ''
	}`.trim();
};

/**
 * Gets formatted address
 * @source Original location: UiUtils.ts.backup line 2156
 */
export const getFormattedAddress = (address: Api.IAddress) => {
	return `${address.address1 ? address.address1 + ' ' : ''}${address.address2 ? address.address2 : ''}, ${
		address.city ? address.city + ', ' : ''
	}${address.stateProvince ? address.stateProvince + ' ' : ''}${address.postalCode || ''}`.trim();
};
